import { SessionContextCanceledError as CanceledError } from '@/lib/session-cancellation';
import { useAuthStore } from '@/stores/auth';
import { useWorkDrafts } from '@/stores/workDrafts';
import { sessionRealm, useSessionRecovery } from '@/stores/sessionRecovery';

export function sessionSnapshot() {
  const { user, sessionRevision } = useAuthStore.getState();
  return `${user?.id ?? ''}:${user?.tenantId ?? ''}:${sessionRealm(user)}:${useWorkDrafts.getState().epoch}:${sessionRevision}:${useSessionRecovery.getState().generation}`;
}

export function captureSession() {
  const snapshot = sessionSnapshot();
  return () => {
    if (snapshot !== sessionSnapshot()) throw new CanceledError('Contexto da clínica alterado');
  };
}
